export enum UserLocalization {
  en_US = 'en_US',
  ru_UA = 'ru_UA',
  uk_UA = 'uk_UA',
}

export interface Locale {
  [UserLocalization.en_US]?: string;
  [UserLocalization.ru_UA]?: string;
  [UserLocalization.uk_UA]?: string;
  [key: string]: string | undefined;
}

export interface EnumLocalizationFields {
  field: string;
  locale: Locale;
  color: string;
}

export interface EnumLocalization {
  enumName: string;
  businessObject: string; // EntityTypeName
  enumFields: EnumLocalizationFields[];
}
